import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import moment from 'moment';

export default class Excess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: props.data || null,
    };
  }
  handleEditClick(e){
    this.props.editModalManage(this.state.data.id);
  }
  handleDeleteClick(e){
    var that = this;
    this.setState({isLoading: true});
    $.ajax({
      url: '/api/v1/portal/drivers/excesses/'+this.state.data.id+'/delete',
      method: 'POST',
      data: {api_token: window.api_token,driver_id:that.state.data.driver_id},
      cache: false
    })
    .done(function(response) {
      that.setState({isLoading: false});
      that.props.handleExcessesTableRefresh();
      that.props.handleCallParentMethod(response.total);
    });
  }
  render() {
        
    let details =   [];
    if(this.state.data.start_date != null && this.state.data.end_date != null){
      let startDate = (this.state.data.start_date != null) ? moment(this.state.data.start_date).format("YYYY-MM-DD") : "";        
      let endDate = (this.state.data.end_date != null) ? moment(this.state.data.end_date).format("YYYY-MM-DD") : "";  
      details.push(
        <span key={this.state.data.start_date}>Start Date:-{startDate}</span>
      );
      details.push(
        <span key={this.state.data.end_date}>End Date:-{endDate}</span>
      );
    }else if(this.state.data.selected_day != null){
      details.push(
        <span key={this.state.data.selected_day}>Selected Day:-{this.state.data.selected_day}</span>
      );
    }else if(this.state.data.selected_starttime != null && this.state.data.selected_endtime != null){
      details.push(
        <span key={this.state.data.selected_starttime}>
          Start Time:- {this.state.data.selected_starttime}
          </span>
      );
      details.push(
        <span key={this.state.data.selected_endtime}>
          End Time:- {this.state.data.selected_endtime}
          </span>
      );
    }
    return (
      // <div className="row">
      //   <div className="col-md-2">
      //     {this.state.data.description}
      //   </div>
      //   <div className="col-md-2" title="reference">
      //     {this.state.data.insurance_reference}
      //   </div>
      //   <div className="col-md-2">
      //     &pound;{this.state.data.amount_paid} / &pound;{this.state.data.original_amount_to_repay}
      //   </div>
      //   <div className="col-md-2">
      //     &pound;{this.state.data.agreed_deduction_amount} {this.state.data.deduction_occurance}
      //   </div>
      //   <div className="col-md-4 details">
      //     {details}
      //   </div>
      // </div>
      <tr>
        <td>{this.state.data.description}</td>
        <td>{this.state.data.insurance_reference}</td>
        <td>&pound;{this.state.data.amount_paid} / &pound;{this.state.data.original_amount_to_repay}</td>
        <td>&pound;{this.state.data.agreed_deduction_amount} {this.state.data.deduction_occurance}</td>
        <td>{details}</td>
        <td className="text-center">
          <a title="Edit" className="user-click-event" onClick={(e)=>this.handleEditClick(e)}><i className="fa fa-edit fa-lg"></i></a>
        </td>
        <td className="text-center">
            <a title="Delete" className="user-click-event" onClick={(e)=>this.handleDeleteClick(e)}>
                <i className="fa fa-trash fa-lg"></i>
                {(this.state.isLoading) ? 
                <i className="fa fa-spinner fa-pulse"></i> : ""}
            </a>
        </td>
      </tr>
      
    );
  }

}
